var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokens(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1663 10.7917V13.875C16.1663 16.475 13.7413 18.5834 10.7497 18.5834C7.75801 18.5834 5.33301 16.475 5.33301 13.875V10.7917C5.33301 13.3917 7.75801 15.25 10.7497 15.25C13.7413 15.25 16.1663 13.3917 16.1663 10.7917Z",
    stroke: "#2B292D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1663 6.62502C16.1663 7.38336 15.958 8.08335 15.5913 8.68335C14.6997 10.15 12.8663 11.0834 10.7497 11.0834C8.63301 11.0834 6.79968 10.15 5.90801 8.68335C5.54134 8.08335 5.33301 7.38336 5.33301 6.62502C5.33301 5.32502 5.94134 4.15002 6.91634 3.30002C7.89967 2.44169 9.24967 1.91669 10.7497 1.91669C12.2497 1.91669 13.5997 2.44169 14.583 3.29169C15.558 4.15002 16.1663 5.32502 16.1663 6.62502Z",
    stroke: "#2B292D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1663 6.62502V10.7917C16.1663 13.3917 13.7413 15.25 10.7497 15.25C7.75801 15.25 5.33301 13.3917 5.33301 10.7917V6.62502C5.33301 4.02502 7.75801 1.91669 10.7497 1.91669C12.2497 1.91669 13.5997 2.44169 14.583 3.29169C15.558 4.15002 16.1663 5.32502 16.1663 6.62502Z",
    stroke: "#2B292D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokens);
export default __webpack_public_path__ + "static/media/tokens.ca6476dfa4d5fbbd246086504def7c43.svg";
export { ForwardRef as ReactComponent };